import { Directionality } from '@angular/cdk/bidi';
import { NgClass } from '@angular/common';
import {
  booleanAttribute,
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
} from '@angular/core';
import { Popover } from 'primeng/popover';
import { OverlayHoverOpenerDirective } from '../../directives/overlay-hover-opener/overlay-hover-opener.directive';
import { PropertyTranslatorPipe } from '../../pipes';

@Component({
  selector: 'app-value-based-tooltip',
  imports: [
    Popover,
    OverlayHoverOpenerDirective,
    PropertyTranslatorPipe,
    NgClass,
  ],
  templateUrl: './value-based-tooltip.component.html',
  styleUrl: './value-based-tooltip.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ValueBasedTooltipComponent {
  directionality = inject(Directionality);
  focusable = input(false, { transform: booleanAttribute });
  autoHide = input(false, { transform: booleanAttribute });
  styleClass = input<string | number>('');
  icon = input<string>('pi pi-info');
  // Direct Value Input
  value = input<any>();

  // Property Key Input
  propertyKey = input<string | number>();
  dataSource = input<{ [key: string]: any }>();
  position = input<'top' | 'bottom' | 'left' | 'right' | 'end' | 'start'>(
    'bottom',
  );

  protected calculatedPosition = computed<'top' | 'bottom' | 'left' | 'right'>(
    () => {
      const position = this.position();
      if (position === 'end' || position === 'start') {
        return this.directionality.value === 'rtl' ? 'left' : 'right';
      }
      return position;
    },
  );

  protected tabIndex = computed(() => (this.focusable() ? 0 : -1));
  protected tooltipEvent = computed(() =>
    this.focusable() ? 'both' : 'hover',
  );

  protected displayedValue = computed(() => {
    if (this.value()) {
      return this.value();
    }

    if (!this.dataSource() || !this.propertyKey()) {
      return null;
    }

    return this.dataSource()[this.propertyKey()];
  });

  protected isArray(value: any): boolean {
    return Array.isArray(value);
  }

  protected asArray(value: any): any[] {
    return value as any[];
  }
}
